import _ from 'lodash'
import React, { Component } from 'react'
import { FadeLoader } from 'react-spinners'
import { TextField } from '@material-ui/core'
import withStore from '../lib/withStore'
import * as StyledComponent from '../styles'
import I18n from '../lib/i18n'
import * as API from '../api'
import CountryCodeSelector from './CountryCodeSelector'
import Modal from './Modal'

class InfoForm extends Component {
  constructor(props) {
    super(props)
    
    this.state = {
      first_name: '',
      last_name: '',
      country_code: this.props.store.system_settings['phone.country_calling_code.shopping_list.cdb'][0] || '',
      phone: '',
      accept_pics: true,
      loading: false
    }
  }

  componentDidMount() {
    const user_info = API.getStorage('user_info')

    if (!_.isEmpty(user_info)) {
      this.setState({ ...user_info })
    }
  }

  handleOpenPICSModal = () => {
    this.props.setPICSModalProps()
    this.props.onOpenPICS()
  }

  handleFieldUpdate = key => e => {
    this.setState({ [key]: e.target.value })
  }

  handleCheckPICS = () => {
    this.setState({ accept_pics: !this.state.accept_pics })
  }

  handleSubmit = async (required_validation) => {
    let error

    required_validation && API.setStorage('user_info', this.state)

    if (required_validation) {
      this.setState({ loading: true })
      try {
        await API.validatePhone(this.state.country_code + this.state.phone)
      } catch(err) {
        error = err
      }

      this.setState({ loading: false })
    }

    if (error) {
      this.handleError(error)
      return
    }

    this.props.onSubmit(required_validation ? _.omit(this.state, 'loading') : {})
  }

  handleError = (err) => {
    const error = API.handleError(err)

    this.saveToStore({ alert_message: error.error_message }, () => this.props.store.flash.open())
  }

  saveToStore = (state, cb) => {
    this.props.store.save(state, cb)
  }

  render() {
    const { store } = this.props
    const { system_settings = {} } = store
    const selectable_country_codes = system_settings['phone.country_calling_code.shopping_list.cdb'] || []

    return <StyledComponent.InfoForm>
      <h4>{ I18n.t('containers.info_form.title') }</h4>
      <h5>{I18n.t('containers.info_form.register_message')}</h5>
      <div className='input-container'>
        <TextField
          className='input-field'
          id='first_name'
          label={I18n.t('containers.info_form.first_name')}
          value={this.state.first_name}
          onChange={this.handleFieldUpdate('first_name')}
          margin="normal"
        />
      </div>
      <div className='input-container'>
        <TextField
          className='input-field'
          id='last_name'
          label={I18n.t('containers.info_form.last_name')}
          value={this.state.last_name}
          onChange={this.handleFieldUpdate('last_name')}
          margin="normal"
        />
      </div>
      <div className='input-container phone'>
        <CountryCodeSelector
          selectable_country_codes={selectable_country_codes}
          country_code={this.state.country_code}
          onChange={this.handleFieldUpdate('country_code')}
        />
        <TextField
          className='input-field phone'
          id='phone'
          label={I18n.t('containers.info_form.phone')}
          value={this.state.phone}
          onChange={this.handleFieldUpdate('phone')}
          margin="normal"
          required
        />
      </div>
      <div id='required'>
        <span>* </span>
        { I18n.t('containers.info_form.required')}
      </div>
      <div id='pics'>
        <div
          className={`checkbox ${this.state.accept_pics ? 'checked' : ''}`}
          name='accept_pics'
          onClick={this.handleCheckPICS}
        />
        <div className='pics_statement'>
          { I18n.t('containers.info_form.accept_pics') }
          <u onClick={this.handleOpenPICSModal}>{I18n.t('containers.info_form.pics_title')}</u>
          { I18n.t('containers.info_form.accept_pics_2') }
        </div>
      </div>
      <button className='submit-btn' onClick={this.handleSubmit.bind(this, true)}>
       {
         this.state.loading
          ? <FadeLoader
              color={'#a3a3a3'}
              css={{
                margin: 'auto',
                transform: 'scale(0.7)',
                transformOrigin: '-20% -20%'
              }}
            />
          : I18n.t('containers.info_form.place_order') }
      </button>
      <div className='guest-checkout' onClick={this.handleSubmit.bind(this, false)}>
        <div>{ I18n.t('containers.info_form.guest_checkout') }</div>
      </div>
    </StyledComponent.InfoForm>
  }
}

export default withStore(InfoForm)



// WEBPACK FOOTER //
// ./src/components/InfoForm.js